import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import Text from '../../shared/Typography';
import CodeBlock from './CodeBlock';

import TextInput from '../../shared/TextInput';
import SurveyQuestion from '../../shared/Question';
import data from './mockData';

type State = {
  formExample: {
    name: string,
    email: string,
    city: string,
    pets: Array
  }
}

type Props = WithTranslation

class Forms extends React.Component<Props, State> {
  state: State = {
    formExample: {
      name: '',
      email: '',
      city: '',
      pets: []
    }
  }

  props: Props;

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Text h2 className='pattern-library__title'>{t('forms')}</Text>
        <CodeBlock>{t('info')}</CodeBlock>

        <TextInput
          name='name'
          value={this.state.formExample.name}
          label={t('name')}
          onChange={(e) => this.setState({
            formExample: Object.assign({}, this.state.formExample, { name: e.target.value })
          })}
        >
          <ul>
            <li>{t('tip_one')} </li>
            <li>{t('tip_two')} </li>
          </ul>
        </TextInput>
        <TextInput
          name='email'
          value={this.state.formExample.name}
          label={t('email')}
          onChange={(e) => this.setState({
            formExample: Object.assign({}, this.state.formExample, { email: e.target.value })
          })}
          error={t('email_error')}
        />

        <SurveyQuestion
          question={data.questions[0]}
          onAnswerChange={(answers) => this.setState({
            formExample: Object.assign({}, this.state.formExample, { pets: answers })
          })}
        />

      </React.Fragment>
    );
  }
}

export default withTranslation('forms')(Forms);



// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/forms.js